// Chakra Imports
import { Flex } from "@chakra-ui/react";
import PropTypes from "prop-types";
import React from "react";
import AdminNavbarLinks from "./AdminNavbarLinks";

export default function AdminNavbar(props) {
  const { onOpen, sidebarWidth = 240 } = props;

  return (
    <Flex
      position="fixed"
      top="0"
      left={{ base: "0", xl: `${sidebarWidth}px` }}
      right="0"
      h="60px"
      bg="white"
      borderBottom="1px solid"
      borderColor="cream.line"
      boxShadow="0 1px 4px rgba(54,38,22,.06)"
      px={{ base: "16px", md: "24px" }}
      align="center"
      justify="flex-end"
      zIndex="5"
      transition="left .18s ease"
    >
      <AdminNavbarLinks onOpen={onOpen} />
    </Flex>
  );
}

AdminNavbar.propTypes = {
  onOpen: PropTypes.func,
  sidebarWidth: PropTypes.number,
};
